module.exports = __webpack_public_path__ + "static/media/vlinder-logo.ec854d21.png";